const SkillItem = ({
  skill,
  index,
  isActive,
  onToggle,
  related,
  PreviewCard,
  SkillBar,
  onLinkClick,
  categoryName,
}) => (
  <div
    className={`skills__item ${isActive ? "skills__item--active" : ""}`}
    onClick={onToggle}
  >
    {/* <div className="skills__item-header">
      <span>{skill.name}</span>
      <span>{skill.level}%</span>
    </div> */}
    <SkillBar name={skill.name} level={skill.level} index={index} categoryName={categoryName} />
    {/* <div className="skills__progress-bar">
      <div
        className="skills__progress-fill"
        style={{ width: `${skill.level}%` }}
      />
    </div> */}
    {isActive && (related.projects.length > 0 || related.jobs.length > 0) && (
      <div
        className="skills__references"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {related.projects.length > 0 && (
          <div className="skills__reference-section">
            <h4>Related Projects</h4>
            <div className="skills__previews">
              {related.projects.map((project, i) => (
                <PreviewCard
                  key={i}
                  item={project}
                  type="project"
                  onLinkClick={onLinkClick}
                />
              ))}
            </div>
          </div>
        )}
        {related.jobs.length > 0 && (
          <div className="skills__reference-section">
            <h4>Experience</h4>
            <div className="skills__previews">
              {related.jobs.map((job, i) => (
                <PreviewCard
                  key={i}
                  item={job}
                  type="job"
                  onLinkClick={onLinkClick}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    )}
  </div>
);

export default SkillItem;
